import { render, staticRenderFns } from "./watchlist.vue?vue&type=template&id=64fbd00a&scoped=true&"
import script from "./watchlist.vue?vue&type=script&lang=js&"
export * from "./watchlist.vue?vue&type=script&lang=js&"
import style0 from "./watchlist.vue?vue&type=style&index=0&id=64fbd00a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fbd00a",
  null
  
)

export default component.exports